export enum ModuleAuthEnum {
  PABX = 'PABX',
  OMNISMART = 'OMNISMART',
}
